var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('contract-title',{staticClass:"mb-2",attrs:{"title":_vm.options.title.main}}),(_vm.headers && _vm.items)?_c('reference-table',{attrs:{"headers":_vm.headers,"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }